import api from './api';

/**
 * POST plan/convert on billing-service (BIO-1872). The `/v0/companies/v1/...` route this used
 * to call is api-v1's Stripe-only convert (its schema requires a Stripe `token` object); only
 * production rewrites that path to billing-service. The `/billing/...` path reaches
 * billing-service in every environment, the same one app posts to.
 */
export const pay = async (companyId, payload) => {
  const { data } = await api.post(
    `/billing/companies/v1/company/${companyId}/plan/convert`,
    payload
  );

  return data;
};

export default {
  pay,
};
